import { replaceUrlProtocol } from "@/utils/filters";
import _cloneDeep from "lodash/cloneDeep";

const state = {
    readerThemes: [],
    selectedReaderTheme: 0,
    bookInsight: {},
    originalAudiobook: {},
    showReaderMode: false
};

const mutations = {
    SET_READER_THEMES(state, readerThemes = []) {
        state.readerThemes = readerThemes;
    },
    SET_BOOKINSIGHT(state, bookInsight) {
        state.bookInsight = bookInsight;
    },
    SET_ORIGINAL_AUDIOBOOK(state, originalAudiobook) {
        state.originalAudiobook = originalAudiobook;
    },
    SET_SHOW_READER_MODE(state, showReaderMode) {
        state.showReaderMode = showReaderMode;
    },
    SET_SELECTED_READER_THEME(state, selectedReaderTheme) {
        state.selectedReaderTheme = selectedReaderTheme;
    },
    CLEAN_UP_DATA(state) {
        state.readerThemes = [];
        state.selectedReaderTheme = 0;
        state.bookInsight = {};
        state.originalAudiobook = {};
        state.showReaderMode = false;
    },
    SET_READER_THEME_PROGRESS(state, currentScrollPercentages) {
        for (let index = 0; index < currentScrollPercentages.length; index++) {
            state.readerThemes[index].progress = currentScrollPercentages[index];
        }
    }
};

const actions = {
    setShowReaderMode({ commit }, showReaderMode = false) {
        commit("SET_SHOW_READER_MODE", showReaderMode);
    },
    setReaderThemes({ commit }, themes) {
        commit("SET_READER_THEMES", themes);
    },
    setSelectedReaderTheme({ commit }, theme = 0) {
        commit("SET_SELECTED_READER_THEME", theme);
    },
    setBookInsight({ commit }, bookInsight = {}) {
        commit("SET_BOOKINSIGHT", _cloneDeep(bookInsight));
    },
    setOriginalAudiobook({ commit }, originalAudiobook = {}) {
        commit("SET_ORIGINAL_AUDIOBOOK", originalAudiobook);
    },
    setReaderThemeProgress({ commit }, currentScrollPercentages = []) {
        commit("SET_READER_THEME_PROGRESS", _cloneDeep(currentScrollPercentages));
    },
    cleanUpData({ commit }) {
        commit("CLEAN_UP_DATA");
    },
    formatThemes({ dispatch }, themes = []) {
        const formatedThemes = _cloneDeep(themes);
        formatedThemes.map((item) => {
            item.hasAudio = false;
            item.progress = 0 ;
            if (item.audio_url) {
                item.audioSrc = [replaceUrlProtocol(item.audio_url)];
                item.hasAudio = true;
            }
            return item;
        });
        dispatch("setReaderThemes", _cloneDeep(formatedThemes));
    },
    resetProgress({ dispatch, state }) {
        const formatedThemes = _cloneDeep(state.readerThemes);
        formatedThemes.map((item) => {
            item.progress = 0 ;
            return item;
        });
        dispatch("setReaderThemes", _cloneDeep(formatedThemes));
    }
};

const getters = {

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
